import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GITHUB_URL, LIB_VERSION, NPM_URL } from '../version';

/** Глобальная sticky-шапка: название (ссылка на индекс), version-чип (npm), ссылки npm/GitHub. */
@Component({
  selector: 'app-site-header',
  standalone: true,
  imports: [RouterLink],
  template: `
    <a routerLink="/" class="hdr__logo"><span class="hdr__mark">▦</span>ngx-aur-mat-table</a>
    <a class="hdr__ver" [href]="npmUrl" target="_blank" rel="noopener">v{{ version }}</a>
    <nav class="hdr__links">
      <a [href]="npmUrl" target="_blank" rel="noopener">npm</a>
      <a [href]="githubUrl" target="_blank" rel="noopener">GitHub</a>
    </nav>
  `,
  styles: [`
    :host {
      position: sticky; top: 0; z-index: 100;
      display: flex; align-items: center; gap: 12px;
      height: var(--hdr-h); padding: 0 24px; box-sizing: border-box;
      background: rgba(20, 20, 31, .78);
      backdrop-filter: blur(10px);
      border-bottom: 1px solid rgba(255, 255, 255, .06);
      color: #eceaf6;
    }
    a { text-decoration: none; color: inherit; }
    .hdr__logo { display: flex; align-items: center; gap: 9px; font-weight: 500; font-size: 15.5px; min-width: 0; }
    .hdr__mark {
      width: 22px; height: 22px; border-radius: 6px;
      background: linear-gradient(135deg, var(--accent), var(--accent-blue));
      display: grid; place-items: center; font-size: 12px; color: #fff;
      flex-shrink: 0;
    }
    .hdr__ver {
      font-size: 12px; font-weight: 600; padding: 2px 9px; border-radius: 999px;
      background: rgba(124, 77, 255, .22); color: var(--accent-soft);
      border: 1px solid rgba(124, 77, 255, .45);
      flex-shrink: 0;
    }
    .hdr__links { margin-left: auto; display: flex; gap: 18px; font-size: 13.5px; color: #b9b7c9; flex-shrink: 0; }
    .hdr__links a:hover { color: #fff; }

    /* < 768px: ряд может не влезть по ширине (лого + чип + ссылки) — разрешаем
       перенос вместо горизонтального скролла страницы; десктоп (>= 768px) не трогаем. */
    @media (max-width: 767px) {
      :host {
        flex-wrap: wrap;
        height: auto;
        min-height: var(--hdr-h);
        padding: 8px 16px;
        row-gap: 6px;
      }
    }
  `],
})
export class SiteHeaderComponent {
  readonly version = LIB_VERSION;
  readonly npmUrl = NPM_URL;
  readonly githubUrl = GITHUB_URL;
}
